import { observer } from 'mobx-react';

interface Props {
  children: React.ReactNode;
}

function FilterContainer({ children }: Props) {
  return (
    <div className="mx-auto box-border flex gap-x-2 pt-0 xl:container md:flex-wrap md:gap-x-0">
      <div className="flex w-full flex-col gap-2 lg:flex-row">{children}</div>
    </div>
  );
}

export default observer(FilterContainer);
